@if (actionConfig) {
  <oaibox-stats-card [title]="actionConfig.name" [icon]="actionConfig.icon" [gradient]="actionConfig.gradientColor">
    <form class="form" [formGroup]="selectVersionForm">
      <div>
        <label class="form-label">gNB Version</label>
        <div class="dropdown">
          <input class="form-control dropdown-toggle" type="text" formControlName="selectedVersion" spellcheck="false"
                 (focus)="showMatches = true" (keyup.enter)="showMatches = false" placeholder="Select version">
          <ul id="gnb-versions-list" class="dropdown-menu" role="menu" aria-labelledby="selected-gnb-version"
              [class.show]="showMatches">
            @for (version of matchedVersions; track $index) {
              <li role="menuitem">
                <button type="button" class="dropdown-item" [class.selected]="selectVersionForm.value.selectedVersion === version"
                        (click)="selectVersion(version)">
                  {{ version }}
                </button>
              </li>
            }
          </ul>
        </div>
        <p class="info">
          <i class="fa-solid fa-circle-info"></i> Before proceeding choose the upgrade version
        </p>
      </div>
    </form>
    <div class="modal-buttons-container p-g">
      <button class="btn btn-ignore" (click)="cancel()">Cancel</button>
      <button class="btn btn-{{actionConfig.gradientColor}} modal-confirmation-button" (click)="confirmAction()"
              [disabled]="selectVersionForm.invalid">
        Proceed
      </button>
    </div>
  </oaibox-stats-card>
}
